module.exports = __webpack_public_path__ + "static/media/img91.b4633026.jpg";